import { fetchApi } from '../client';

/** Per-clinic patient-engagement settings (appointment reminders + follow-up recall). */
export interface EngagementSettings {
  remindersEnabled: boolean;
  reminderLeadHours: number;
  recallEnabled: boolean;
  recallLeadDays: number;
}

/** Rolling dispatch stats for the engagement dashboard. */
export interface EngagementStats {
  windowDays: number;
  remindersSent: number;
  recallsSent: number;
  failures: number;
}

export const engagementModule = {
  getSettings: () =>
    fetchApi<EngagementSettings>('/api/engagement/settings'),

  updateSettings: (settings: EngagementSettings) =>
    fetchApi<EngagementSettings>('/api/engagement/settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
    }),

  getStats: () =>
    fetchApi<EngagementStats>('/api/engagement/stats'),

  getWhatsAppSettings: () =>
    fetchApi<WhatsAppSettingsResponse>('/api/clinic/whatsapp-settings'),

  saveWhatsAppSettings: (payload: WhatsAppSettingsPayload) =>
    fetchApi<{ message: string }>('/api/clinic/whatsapp-settings', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  disableWhatsApp: () =>
    fetchApi<{ message: string }>('/api/clinic/whatsapp-settings', { method: 'DELETE' }),

  /** Delivery visibility: sent/logged/failed WhatsApp messages (masked recipient, no PHI). */
  getWhatsAppOutbox: (page = 0, size = 25) =>
    fetchApi<{ data: WhatsAppOutboxRow[]; total: number }>(
      `/api/clinic/whatsapp-settings/outbox?page=${page}&size=${size}`),
};

export interface WhatsAppOutboxRow {
  id: string;
  toMasked: string;
  templateName: string;
  status: string;        // LOGGED | SENT | FAILED
  errorMessage?: string | null;
  createdAt?: string;
}

export type WhatsAppProvider = 'META' | 'GUPSHUP';

export interface WhatsAppSettingsResponse {
  configured: boolean;
  provider?: WhatsAppProvider;
  phoneNumberId?: string;
  fromNumber?: string;
  appName?: string;
  isActive?: boolean;
  accessTokenHint?: string;
}

export interface WhatsAppSettingsPayload {
  provider: WhatsAppProvider;
  accessToken: string;
  phoneNumberId?: string;
  fromNumber?: string;
  appName?: string;
}
